import { TProductCart } from 'src/store';

import styles from './Cart.module.scss';
import { Icon, Link, TableBox, TableRowEmpty } from 'src/components';
import { CartRow } from './components';
import { useState } from 'react';
import { LC_KEY_IS_HIDDEN_CART, LocalStorage } from 'src/toolkit';
import { PATH_ACCOUNT_PRODUCT_CART } from 'src/routes';


type TProps = {
	className?: string;
	classNames?: string[];
	items: TProductCart[];
};

export function Cart(props: TProps) {
	const isHiddenDefault = LocalStorage.get(LC_KEY_IS_HIDDEN_CART) === true;
	const [isHidden, setIsHidden] = useState(isHiddenDefault);

	const {
		className,
		classNames: classNamesOuter = [],
		items = [],
	} = props;

	const classNames = [styles.box, 'scroll-box', ...classNamesOuter];

	if (className) {
		classNames.push(className);
	}

	if (isHidden) {
		classNames.push(styles.isHidden);
	}

	const theadSettings = {
		// sort,
		// setSort: (value: TTableSort) => dispatch(setAccountProductCartListQuerySort(value)),
		// sortCol,
		// setSortCol: (value: TProductCartListSortCol) => dispatch(setAccountProductCartListQuerySortCol(value)),
		items: [
			// { name: 'ID' },
			{ name: 'Позиция' },
			{ name: 'Серийный номер' },
			{ name: 'Поставщик' },
			{ name: 'Описание' },
			{ name: 'Цена' },
			{ name: 'Склад' },
			{ name: 'Количество' },
		],
	};

	const onClick = (value: boolean) => {
		LocalStorage.set(LC_KEY_IS_HIDDEN_CART, value);

		setIsHidden(value);
	};

	const icon = isHidden ? 'icon-cart' : 'icon-minus';

	if (items.length <= 0) {
		return (
			<div className={ classNames.join(' ') }>
				<div className={ styles.legend }>
					<Icon className={ styles.icon } icon={ icon } onClick={ e => onClick(!isHidden) } />
					Корзина
					<Link to={ PATH_ACCOUNT_PRODUCT_CART }>
						<Icon className={ styles.iconLink } icon="icon-cart" />
					</Link>
				</div>
				<TableBox
					// isLoading={ isLoading }
					thead={ theadSettings }
					// control={ controlSettings }
					// pagination={ paginationSettings }
				>
					<TableRowEmpty colSpan={ theadSettings.items.length }>Продукты в корзине не найдены</TableRowEmpty>
				</TableBox>
			</div>
		);
	}

	return (
		<div className={ classNames.join(' ') }>
			<div className={ styles.legend }>
				<Icon className={ styles.icon } icon={ icon } onClick={ e => onClick(!isHidden) } />
				Корзина
				<Link to={ PATH_ACCOUNT_PRODUCT_CART }>
					<Icon className={ styles.iconLink } icon="icon-cart" />
				</Link>
			</div>
			<TableBox
				className={ styles.list }
				// isLoading={ isLoading }
				thead={ theadSettings }
				// control={ controlSettings }
				// pagination={ paginationSettings }
			>
				{
					items.map(item => {
						return (
							<CartRow
								key={ item.id }
								{ ...item }
								// to={ `${PATH_ACCOUNT_PRODUCT_CART}/${item.id}` }
								// selectedItems={ selectedItems }
								// setSelectedItems={ setSelectedItems }
							/>
						);
					})
				}
			</TableBox>
			{/* <div className={ styles.list }>
				{ items.length > 0 &&
					items.map(item => {
						const { id, brand, orderAmount } = item;

						return (
							<div key={ id } className={ styles.item }>
								<span>{ brand.name }</span>
								<span>{ orderAmount }</span>
							</div>
						);
					})
				}
			</div> */}
		</div>
	);
}
